import liff from "@line/liff";

const liffId = process.env.REACT_APP_LIFF_ID;
const isMockMode = process.env.REACT_APP_LIFF_MOCK === "true";

const initialize = async () => {
  if (isMockMode) return;

  if (!liffId) throw new Error("REACT_APP_LIFF_ID is not configured.");

  await liff.init({
    liffId,
    withLoginOnExternalBrowser: true,
  });
};

const getIdToken = () => {
  if (isMockMode) return null;

  return liff.getIDToken();
};

const openWindow = (url: string) => {
  if (isMockMode) {
    window.open(url, "_blank");

    return;
  }

  liff.openWindow({
    url,
    external: false,
  });
};

const closeWindow = () => {
  if (isMockMode) return;

  liff.closeWindow();
};

const liffClient = {
  initialize,
  getIdToken,
  openWindow,
  closeWindow,
  isMockMode,
};

export default liffClient;
